import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status, statusCode } from "../../common/constants";
import { verifyUserInvitationTokenUrl } from "../../config";
import { RootState } from "../../store";
import api from '../../api';

interface IUserDetails {
  name: string;
  email: string;
  role: string;
  organisationId: string;
  organisationName: string;
  groupId: string;
}

interface IInitialState {
  userDetails: IUserDetails;
  status: string;
  error: string | null;
}

const initialState: IInitialState = {
  userDetails: null,
  status: Status.IDLE,
  error: null,
};

export const verifyUserInvitationToken: any = createAsyncThunk('verifyUserInvitationToken', async (verificationToken: string, { rejectWithValue }) => {
    try {
      
    const response = await api.get(verifyUserInvitationTokenUrl + `?token=${verificationToken}`);

      if (response.status === statusCode.ok) {
        return response.data;
      } else {
        throw new Error('Token verification failed');
      }

    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  });


const verifyUserInvitationTokenSlice = createSlice({
  name: "verifyUserInvitationToken",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(verifyUserInvitationToken.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(verifyUserInvitationToken.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.userDetails = action.payload;
      })
      .addCase(verifyUserInvitationToken.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message;
      });
  },
});

export const selector = (state: RootState) => state.verifyUserInvitationTokenApi;

export default verifyUserInvitationTokenSlice.reducer;
